import styled from "styled-components/macro";

export const BreadcrumbsLinkText = styled.div`
  width: 225px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;
